// extracted by mini-css-extract-plugin
export var numberedList = "ArticleNumberedList-module--numberedList--2rc0k";
export var numberCircle = "ArticleNumberedList-module--numberCircle--3Xbjq";
export var numberText = "ArticleNumberedList-module--numberText--2wHji";